import { LAYOUT } from './layout';

interface TotalLoadCardProps {
  x: number;
  y: number;
  totalKw: number;
  feederCount: number;
}

export function TotalLoadCard({ x, y, totalKw, feederCount }: TotalLoadCardProps) {
  const w = LAYOUT.loadCardW;
  const h = LAYOUT.loadCardH;
  const cx = x + w / 2;

  const formatted = totalKw.toLocaleString(undefined, { maximumFractionDigits: 0 });

  return (
    <g>
      <rect
        x={x} y={y} width={w} height={h} rx={12}
        fill="#0c1524" stroke="#1e3a5f" strokeWidth={1.5}
      />
      <text x={cx} y={y + 20} textAnchor="middle" fill="#64748b" fontSize="11" fontWeight="600" letterSpacing="1.5">
        TOTAL LOAD
      </text>
      <text x={cx} y={y + 48} textAnchor="middle" fill="#38bdf8" fontSize="26" fontWeight="700" fontFamily="monospace">
        {formatted}
      </text>
      <text x={cx} y={y + 66} textAnchor="middle" fill="#64748b" fontSize="11">
        {'kW \u00b7 '}{feederCount} feeders
      </text>
    </g>
  );
}
